import classNames from 'classnames';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { CSSTransitionGroup } from 'react-transition-group';

import { closeErrorBar } from 'actions/errorBar';
import { toggleDashboardUpgradeModal } from 'actions/videosDashboard';
import { addBodyClass, getCssVarValue, removeBodyClass } from 'utilities/css';

import './styles.less';

const ERROR_BAR_TRANSITION_DURATION = parseInt(
  getCssVarValue('--errorBarTransitionDuration')
);

const ErrorBar = class extends Component {
  render() {
    const {
      severity,
      message,
      showing,
      onPrimaryAction,
      primaryButtonLabel,
      actionHref,
      inline,
    } = this.props;

    let errorBar = null;

    const errorBarClass = classNames('error-bar', severity, inline && 'inline');

    if (showing) {
      addBodyClass('errorBarIsOpen');
    } else {
      removeBodyClass('errorBarIsOpen');
      addBodyClass('errorBarIsClosing');

      setTimeout(() => {
        removeBodyClass('errorBarIsClosing');
      }, ERROR_BAR_TRANSITION_DURATION);
    }

    if (showing) {
      errorBar = (
        <div className={errorBarClass}>
          <div className="content-wrapper">
            <p>{message}</p>
            <div className="action-container">
              {onPrimaryAction ? (
                <span className="action-button" onClick={onPrimaryAction}>
                  {primaryButtonLabel}
                </span>
              ) : null}
              {actionHref && (
                <a
                  className="action-button"
                  href={actionHref}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {primaryButtonLabel}
                </a>
              )}
              <span className="close" onClick={this.closeHandler}>
                Dismiss
              </span>
            </div>
          </div>
        </div>
      );
    }

    return (
      <CSSTransitionGroup
        transitionName="error-bar"
        transitionEnterTimeout={ERROR_BAR_TRANSITION_DURATION}
        transitionLeaveTimeout={ERROR_BAR_TRANSITION_DURATION}
      >
        {errorBar}
      </CSSTransitionGroup>
    );
  }

  closeHandler = () => {
    const { onCloseCallback, closeErrorBar } = this.props;

    if (onCloseCallback) {
      onCloseCallback();
    }

    closeErrorBar();
  };
};

const mapStateToProps = state => {
  const { severity, message, showing, actionHref, primaryButtonLabel } =
    state.error_bar;

  return { severity, message, showing, actionHref, primaryButtonLabel };
};

const mapDispatchToProps = dispatch => {
  return {
    closeErrorBar: () => dispatch(closeErrorBar()),
    toggleDashboardUpgradeModal: action =>
      dispatch(toggleDashboardUpgradeModal(action)),
  };
};

const mergeProps = (stateProps, dispatchProps) => {
  const { closeErrorBar } = dispatchProps;

  return {
    closeErrorBar,
    ...stateProps,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(ErrorBar);
